class Validator {

  static isEmailValid = (value) => {
    if (!value && value !== '') return false;
    const regex = /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/;
    return regex.test(value);
  }
};

export default Validator;